/**
 * Centralized keyword mappings for different post assessment types.
 * These keywords are used for highlighting and searching within posts.
 */

const ASSESSMENT_KEYWORDS = {
    nps: [
        'awesome amazing shockingly surprised insane loved obsessed thrilled ecstatic phenomenal flawless fantastic incredible outstanding perfect delightful superb unreal',
        'terrible awful worst atrocious unacceptable horrendous abysmal disgusting furious enraged betrayed scammed',
        'ripoff unusable broken shambolic grotesque abominable abhorrent repugnant vile execrable wretched ghastly dreadful',
        'disastrous calamitous ruinous chaotic primitive barbaric insulting offensive criminal fraudulent predatory parasitic treacherous hazardous incoherent nonsensical clumsy clunky sluggish agonizing excruciating torturous suffocating humiliating mortifying',
        'apoplectic incensed irate livid ravenous zealous fanatic fixated addicted hooked mesmerized hypnotic euphoric intoxicating sublime immaculate pristine impeccable masterful invincible'
    ].join(' '),

    pricing: 'pricing price overpriced value pricey cheap expensive cash money costs deal rip-off dollars worth',

    leaver_joiner: 'leave join switch instead moving quitting cancel dropping unsubscribe quit subscribe now recently',

    // Base keywords for competitive comparison (without specific competitor name)
    competitive_comparison_base: 'vs versus better worse cheaper than best worst prefer switch instead'
};

/**
 * Get keywords for a specific assessment type
 * @param {string} assessmentType - The type of assessment (nps, pricing, leaver_joiner, competitive_comparison)
 * @param {Object} options - Additional options (e.g., { competitor: 'CompetitorName' })
 * @returns {string} Space-separated keywords for the assessment type
 */
export const getAssessmentKeywords = (assessmentType, options = {}) => {
    if (!assessmentType) return '';

    const normalizedType = assessmentType.toLowerCase();

    // Handle competitive comparison with dynamic competitor name
    if (normalizedType === 'competitive_comparison' && options.competitor) {
        return `${options.competitor} ${ASSESSMENT_KEYWORDS.competitive_comparison_base}`;
    }

    // Return the keywords for the assessment type, or empty string if not found
    return ASSESSMENT_KEYWORDS[normalizedType] || '';
};

/**
 * Get all assessment keyword mappings
 * @returns {Object} All assessment keyword mappings
 */
export const getAllAssessmentKeywords = () => {
    return { ...ASSESSMENT_KEYWORDS };
};

export default getAssessmentKeywords;
